<template>
  <pt-news-table class="pt-news-table__withData" @getNewsList="getNewsList" :tableLabels="tableLabels" :page-size="page_size" :tableData="tableData" :totalNumber="totalNumber"
  ref="table" :loading="loading" :isOutside="isOutside">
      <slot/>
  </pt-news-table>
</template>

<script>
import PtNewsTable from './index'
export default {
  name: 'pt-news-table__withData',
  components: {
    'pt-news-table': PtNewsTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      totalNumber: 0,
      page_size: this.pageSize,
      tableData: [],
      loading: false,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getNewsList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getNewsList(this.page)
        }
        // this.getNewsList(0)
      }
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getNewsList (page, next) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: this.page_size
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getNewsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取新闻列表失败')
        this.loading = false
      })
    }
  }
}
</script>
